var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#E7E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 13.1667H24.0003C24.6634 13.1667 25.2993 13.4301 25.7681 13.899C26.2369 14.3678 26.5003 15.0037 26.5003 15.6667V23.1667C26.5003 23.8298 26.2369 24.4657 25.7681 24.9345C25.2993 25.4034 24.6634 25.6667 24.0003 25.6667H13.167C12.504 25.6667 11.8681 25.4034 11.3992 24.9345C10.9304 24.4657 10.667 23.8298 10.667 23.1667V15.6667C10.667 15.0037 10.9304 14.3678 11.3992 13.899C11.8681 13.4301 12.504 13.1667 13.167 13.1667ZM13.167 14.0001C12.7503 14.0001 12.3837 14.1417 12.1003 14.3917L18.5837 18.5834L25.067 14.3917C24.7837 14.1417 24.417 14.0001 24.0003 14.0001H13.167ZM18.5837 19.5917L11.6087 15.0667C11.542 15.2501 11.5003 15.4584 11.5003 15.6667V23.1667C11.5003 23.6088 11.6759 24.0327 11.9885 24.3453C12.301 24.6578 12.725 24.8334 13.167 24.8334H24.0003C24.4424 24.8334 24.8663 24.6578 25.1788 24.3453C25.4914 24.0327 25.667 23.6088 25.667 23.1667V15.6667C25.667 15.4584 25.6253 15.2501 25.5587 15.0667L18.5837 19.5917Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFrame);
export default __webpack_public_path__ + "static/media/EmailFrame.1ed1315583a370c452b20703483ffcdf.svg";
export { ForwardRef as ReactComponent };